import { render, staticRenderFns } from "./DocConformity.vue?vue&type=template&id=7d6f4c0a&"
import script from "./DocConformity.vue?vue&type=script&lang=js&"
export * from "./DocConformity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports